'use client';

import {
  ControlType,
  CalculatorId,
  CalculatorType,
  ControlIds,
  type CalculatorConfig,
  DataTableInputMode,
  type ControlValues,
  type SingleColumnSelectControl
} from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { MedianAbsoluteDeviationCalculator } from './median-absolute-deviation-calculator';
import { calculateMedianAbsoluteDeviation } from '../../../lib/stats/median-absolute-deviation';

export interface MedianAbsoluteDeviationControlValues extends ControlValues {
  [ControlIds.Values]: string;
}

export const medianAbsoluteDeviationControls = {
  tabs: [
    {
      title: 'Data',
      controls: [
        {
          id: ControlIds.Values,
          type: ControlType.SingleColumnSelect,
          label: 'Select Data Column',
          required: true,
          numericOnly: true,
          defaultValue: 'prices'
        } as SingleColumnSelectControl
      ]
    }
  ]
};

export const medianAbsoluteDeviationCalculatorConfig: CalculatorConfig<CalculatorId.MEDIAN_ABSOLUTE_DEVIATION> = {
  id: CalculatorId.MEDIAN_ABSOLUTE_DEVIATION,
  type: CalculatorType.Graph,
  name: 'Median Absolute Deviation Calculator',
  dataTableInputMode: DataTableInputMode.Required,
  initialData: TableDataJSON.from({
    columns: [
      { 
        id: 'prices',
        name: 'Stock Prices', 
        values: ['50.25', '50.50', '50.75', '51.00', '50.25', '50.75', '65.00', '50.50', '50.25', '35.00', 
                '50.75', '51.00', '50.25', '50.50', '50.75'] 
      },
      {
        id: 'temperatures',
        name: 'Daily Temperatures (°C)',
        values: ['22.5', '23.1', '22.8', '23.4', '22.9', '23.0', '27.5', '22.7', '22.2', '18.5', 
                '23.1', '23.4', '22.9', '23.0', '22.8']
      }
    ]
  }),
  initialControlValues: {
    [ControlIds.Values]: 'prices'
  },
  controls: medianAbsoluteDeviationControls,
  getInitialConfig: (data: TableDataJSON) => ({
    [ControlIds.Values]: data.columns[0]?.id || ''
  }),
  getVisualizationData: (params: { data: TableDataJSON; controls: ControlValues }) => {
    const columnId = params.controls[ControlIds.Values] as string;
    const values = params.data.columns
      .find(col => col.id === columnId)
      ?.values
      .map(v => Number(v))
      .filter(v => !isNaN(v));
    
    if (!values || values.length === 0) return null;
    return calculateMedianAbsoluteDeviation(values);
  },
  render: ({ visualizationData }) => <MedianAbsoluteDeviationCalculator visualizationData={visualizationData} />
}; 